/* Look Around Apps */

//---- line item property----//
const button = document.getElementById('gift_checkbox');
button.addEventListener('change', function() { 
 console.log(this.checked,'$(this).checked');
 if(this.checked) {
  $('.form-container').fadeIn();  
 }else{
   $('.form-container').fadeOut();
   $('p.line-item-property__field > #input-id').val(" ");       
 }
})
if(document.querySelectorAll('.product-section').length > 0){
window.addEventListener('load', function() {
  // equalizeHeights(); // Call the function to equalize heights when the page loads
});

window.addEventListener('resize', function() {
  // equalizeHeights(); // Adjust the heights when resizing the window
});

function equalizeHeights() {
  const items = document.querySelectorAll('.product-section');
  let maxHeight = 0;

  // Reset the height before recalculating
  items.forEach(item => {
      console.log('innnnnnnnnn');
    item.style.height = 'auto'; // Reset any previously set height
  });

  // Find the maximum height of the items
  items.forEach(item => {
    maxHeight = Math.max(maxHeight, item.offsetHeight);
  });

  // Apply the maximum height to all items
  items.forEach(item => {
    item.style.height = `${maxHeight}px`;
  });
}
}